let language = {
    DETAIL_RECOMMEND_TITLE: "You might also like",
    DETAIL_RECOMMEND_TIPS: "Product image missing",
}

export { language }